// extracted by mini-css-extract-plugin
export default {"testimonial-card":"AllTestimonials_testimonial-card__paeOF"};